class Animations {
    static easing = [0.6, -0.05, 0.01, 0.99];
    static buttoneasing = [1, 1, 0.5, 0];


    static GRID_BUTTON_ADD = {
        initial: {
            fill: "#C9CACF",
        },
        rest: {
            fill: "#C9CACF",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        iconblue: {
            fill: "#51C0E2",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        icongray: {
            fill: "#C9CACF",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        hover: {
            fill: "#51C0E2",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        }
    }

    static GRID_BUTTON_ICON = {

        initial: {
            borderColor: "#EAE9E8",
            fill: "#C9CACF",
        },
        animate: {
            borderColor: "#EAE9E8",
            fill: "#C9CACF",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        iconblue: {
            borderColor: "#51C0E2",
            fill: "#51C0E2",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        icongray: {
            borderColor: "#EAE9E8",
            fill: "#C9CACF",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        hover: {
            borderColor: "#51C0E2",
            fill: "#51C0E2",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        }
    }

    static LIST_ROW_ITEM = {
        initial: {
            borderColor: "#C9CACF",
            fill: "#C9CACF",
        },
        animate: {
            borderColor: "#C9CACF",
            fill: "#C9CACF",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        iconblue: {
            borderColor: "#51C0E2",
            fill: "#51C0E2",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        icongray: {
            borderColor: "#C9CACF",
            fill: "#C9CACF",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        },
        hover: {
            borderColor: "#51C0E2",
            borderWidth: "2px",
            fill: "#51C0E2",
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        }
    }

    static LIST_ROW = {

        initial: {
            y: 60,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.6,
                ease: Animations.easing
            }
        },
        hover: {
            scale: 1.01,
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        }
    }

    static GRID_BUTTON = {

        initial: {
            y: 60,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.6,
                ease: Animations.easing
            }
        },
        hover: {
            scale: 1.02,
            transition: {
                duration: 0.1,
                ease: Animations.buttoneasing
            }
        }
    }

    static GRID_BUTTON_HOVER_ANIMATION = {
        scale: 1.08,
        transition: {
            duration: 0.1,
            ease: Animations.buttoneasing
        }
    }
    static FADE_IN = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1,
            transition: {
                duration: 0.6,
                ease: Animations.easing
            }
        }
    }

    static FADE_IN_UP = {
        initial: {
            y: 60,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.6,
                ease: Animations.easing
            }
        }
    }

    static ACTIVE_BUTTON = {
        hover: {
            scale: 1.2
        },
        tap: {
            scale: 0.95
        }
    }

    static FADE_IN_RIGHT = {
        initial: {
            x: -60,
            opacity: 0
        },
        animate: {
            x: 0,
            opacity: 1,
            transition: {
                duration: 0.6,
                ease: Animations.easing
            }
        }
    }

    static SUBMENU_UP = {
        y: 0, transition: {
            ease: "linear",
            duration: 0.3
        }
    }

    static SUBMENU_DOWN = {
        y: 100, transition: {
            ease: "linear",
            duration: 0.3
        }
    }

    static SLIDE_DOWN = {
        initial: {
            y: -100,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.6,
                ease: Animations.easing
            }
        }
    }

    static STAGGER = {
        animate: {
            transition: {
                staggerChildren: 0.1
            }
        }
    }

    // Staggered list — items cascade in one by one (used on screens, playlists, etc.)
    static LIST_CONTAINER = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.07,
                delayChildren: 0.05,
            }
        }
    }

    static LIST_ITEM = {
        hidden: { opacity: 0, y: 22 },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.42,
                ease: [0.25, 0.46, 0.45, 0.94],
            }
        }
    }

    // Page-level enter animation — matches Lite Mode's fadeUp spring
    static PAGE_ENTER = {
        initial: {
            opacity: 0,
            y: 18,
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.35,
                ease: [0.4, 0, 0.2, 1],
            }
        },
        exit: {
            opacity: 0,
            y: -8,
            transition: {
                duration: 0.18,
                ease: [0.4, 0, 1, 1],
            }
        }
    }

}

export default Animations